import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, obj = auth
  const [settings, setSettings] = useState(null);

  const loadUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const s = await api.get("/settings");
        setSettings(s.data);
      } catch (_) {}
      return data;
    } catch (e) {
      setUser(false);
      return null;
    }
  };

  useEffect(() => { loadUser(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem("ef_token", data.token);
    setUser(data);
    try {
      const s = await api.get("/settings");
      setSettings(s.data);
    } catch (_) {}
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("ef_token");
    setUser(false);
  };

  const refreshSettings = async () => {
    try {
      const s = await api.get("/settings");
      setSettings(s.data);
    } catch (_) {}
  };

  return (
    <AuthContext.Provider value={{ user, settings, login, logout, loadUser, refreshSettings, setSettings }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiError };
